<mat-expansion-panel [expanded]="open" (opened)="onOpen()" (closed)="onClose()" class="group-panel menu-items-panel">
    <mat-expansion-panel-header>
        <mat-panel-title>
            {{title}}
        </mat-panel-title>
    </mat-expansion-panel-header>

    <div fxLayout="column">
        <ng-content></ng-content>
    </div>
</mat-expansion-panel>
